<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.846 3c-.363 0-.696.114-.98.305L11.26 13.379c.455.441 1.045.441 1.5 0L23.135 3.305A1.752 1.752 0 0 0 22.154 3H1.846zM.116 4.299c-.07.208-.116.425-.116.659v13.084c0 .398.108.764.298 1.072l7.346-7.506-7.529-7.31zm23.769 0-7.51 7.3 7.327 7.515c.19-.308.298-.675.298-1.072V4.958c0-.235-.045-.452-.115-.66zm-8.404 8.175-1.875 1.82c-.893.867-2.3.866-3.192 0l-1.876-1.81-7.269 7.418c.182.063.375.098.577.098h20.308c.202 0 .395-.035.577-.098l-7.25-7.428z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
